/*eslint-disable */
import i18n from '../locales';
import axios from 'axios';
import store from '../store';
import Multiselect from 'vue-multiselect';
import showAlert from '../alert/alertHandler';

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import moment from 'moment';

import tripsEscl from '../locales/es-CL/trips.json';
import tripsEsmx from '../locales/es-MX/trips.json';
import tripsEsco from '../locales/es-CO/trips.json';
import tripsEnus from '../locales/en-US/trips.json';

export default {
  name: 'TripsForm',
  props: ['item', 'action', 'callback'],
  components: {
    Multiselect,
    VueCtkDateTimePicker,
  },
  data() {
    return {
      launched: false,
      form: {},
    };
  },
  computed: {
    options() {
      return {};
    },

    titulo() {
      if (this.action === 'create') {
        return this.t('trips.formulario.titulos.createFormTitle', { tripId: this.form.id });
      } else {
        if (this.action === 'edit') {
          return this.t('trips.formulario.titulos.editFormTitle', { tripId: this.form.id });
        } else {
          return this.t('trips.formulario.titulos.viewFormTitle', { tripId: this.form.id });
        }
      }
    },
  },
  methods: {
    closeModal() {
      this.$bvModal.hide('trips-form-modal');
    },
    formatNominalTime(value) {
      let date = new Date(null);
      date.setSeconds(value); // specify value for SECONDS here
      return date.toISOString().substr(11, 8);
    },
    setForm() {
      return {
        id: this.item ? this.item.id : '',
        route: this.item ? this.item.route : '',
        name: this.item ? this.item.name : '',
        address: this.item ? this.item.address : '',
        start: this.item ? moment(this.item.startDate).format('YYYY-MM-DD hh:mm:ss') : '',
        end: this.item ? moment(this.item.endDate).format('YYYY-MM-DD hh:mm:ss') : '',
        activities: this.item ? this.item.activities : '',
        extra: this.item ? this.item.extra : '',
        contactName: this.item && this.item.contact ? this.item.contact.name : '',
        contactPhone: this.item && this.item.contact ? this.item.contact.phone : '',
        contactEmail: this.item && this.item.contact ? this.item.contact.email : '',
        extraData: this.item && this.item.extraData ? Object.values(this.item.extraData) : '',
      };
    },
    validate() {
      if (!this.meetRequirement(this.form.id)) {
        this.showPopover('id');
        return false;
      }

      if (!this.meetRequirement(this.form.route)) {
        this.showPopover('route');
        return false;
      }

      if (!this.meetRequirement(this.form.name)) {
        this.showPopover('name');
        return false;
      }

      if (!this.meetRequirement(this.form.address)) {
        this.showPopover('address');
        return false;
      }

      if (!this.meetRequirement(this.form.start)) {
        this.showPopover('start');
        return false;
      }

      if (!this.meetRequirement(this.form.end)) {
        this.showPopover('end');
        return false;
      }

      if (!this.meetRequirement(this.form.activities)) {
        this.showPopover('activities');
        return false;
      }

      if (!this.meetRequirement(this.form.contactName)) {
        this.showPopover('contactName');
        return false;
      }

      if (!this.meetRequirement(this.form.contactPhone)) {
        this.showPopover('contactPhone');
        return false;
      }

      if (!this.meetRequirement(this.form.contactEmail)) {
        this.showPopover('contactEmail');
        return false;
      }

      if (!this.meetEmailRequirement(this.form.contactEmail)) {
        this.showPopover('contactEmail');
        return false;
      }
      return true;
    },
    meetRequirement(field) {
      return !!field && !!String(field).trim().length;
    },
    meetLengthRequirement(field, minLength, maxLength) {
      let extension = !!String(field).trim().length;
      return extension >= minLength && extension <= maxLength;
    },
    meetNumberRequirement(field) {
      return !isNaN(field);
    },
    meetEmailRequirement(field) {
      return /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$/.test(field);
    },
    meetNumberSizeRequirement(field, min, max) {
      return Number(field) >= min && Number(field) <= max;
    },
    meetRegularExpressionRequirement(field, re) {
      return re.test(field);
    },
    hidePopover(id) {
      this.$root.$emit('bv::hide::popover', id);
      document.getElementById(id).classList.remove('wrong-input');
    },
    showPopover(id) {
      this.$root.$emit('bv::show::popover', id);
      document.getElementById(id).classList.add('wrong-input');
    },
    t(key) {
      return i18n.t(key);
    },
    t(key, data) {
      return i18n.t(key, data);
    },
    async confirm() {
      this.launched = true;
      if (this.validate()) {
        const url = `MOCK`;
        const config = {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
          },
        };
        try {
          let body = this.form;

          //se obtiene el valor de los multiselect

          if (this.action === 'create') {
            if (url === 'MOCK') {
              body.id = Math.floor(Math.random() * (9999999 - 1000 + 1)) + 1000;
            } else {
              const response = await axios.post(url, body, config);
              body = response.data.data;
            }
          } else {
            body.id = this.item.id;
            if (url !== 'MOCK') {
              const response = await axios.patch(url + '/' + body.id, body, config);
              body = response.data.data;
            }
          }
          if (this.callback) {
            this.callback(body);
          }
          this.$bvModal.hide('trips-form-modal');
        } catch (e) {
          this.launched = false;
          showAlert(this.t('trips.formulario.error.titulo'), this.t('trips.formulario.error.mensaje'), 'error');
          console.log(e);
        }
      } else {
        this.launched = false;
      }
    },
  },
  async mounted() {
    this.$root.$on('bv::modal::hide', () => {
      setTimeout(() => {
        this.$destroy(); // cleanup in component
        this.$el.remove();
      }, 500);
    });

    i18n.setLocaleMessage('es-CL', {
      ...i18n.messages['es-CL'],
      trips: tripsEscl,
    });

    i18n.setLocaleMessage('es-MX', {
      ...i18n.messages['es-MX'],
      trips: tripsEsmx,
    });

    i18n.setLocaleMessage('es-CO', {
      ...i18n.messages['es-CO'],
      trips: tripsEsco,
    });

    i18n.setLocaleMessage('en-US', {
      ...i18n.messages['en-US'],
      trips: tripsEnus,
    });
    this.form = this.setForm();
  },
};
